import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import FullWidthLayout from "./layouts/FullWidthLayout.vue";
import AdminLayout from "./layouts/AdminLayout.vue";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";
import VeeValidatePlugin from "./plugins/vee-validate";
import AxiosPlugin from "./plugins/axios";
import "@/styles/main.scss";

Vue.config.productionTip = false;
Vue.component("full-width-layout", FullWidthLayout);
Vue.component("admin-layout", AdminLayout);
Vue.component("DataTable", () =>
  import("@/components/data-table/DataTable.vue")
);
Vue.component("DatePicker", () =>
  import("@/components/date-picker/DatePicker.vue")
);
Vue.use(VueTelInputVuetify, {
  vuetify,
});
Vue.use(AxiosPlugin);
Vue.use(VeeValidatePlugin);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
